import axios from "axios"
import reportError from "../../services/http/responseErrorInterceptors/reportError"
import AuthenticationService from "../AuthenticationService/AuthenticationService"

const apiClient = async ({ withAuth = false } = {}) => {
  const baseURL = process.env.VUE_APP_API_GATEWAY_URL_V2
  const header = {
    "Content-Type": "application/json"
  }

  if (withAuth) {
    const token = await AuthenticationService.getAccessTokenAndRenewIfNeeded({
      ignoreRefreshCookie: true
    })

    header.Authorization = `Bearer ${token}`
  }

  const api = axios.create({
    baseURL,
    "Cache-Control": "no-cache",
    headers: header
  })

  api.interceptors.response.use(
    response => response,
    error => reportError(error)
  )

  return api
}

export default {
  async getQuote(data) {
    const api = await apiClient()
    return api.post("/api/v1/quotes", data)
  },
  async getForPostcode(customerPostcode) {
    const api = await apiClient()
    return api.get(`api/v1/addresses/${customerPostcode}`)
  },
  async getAgreements(accountId) {
    const api = await apiClient({ withAuth: true })
    return api.get(`/api/v1/accounts/${accountId}/agreements`)
  },
  async getSmartPayAsYouGoEligibility(accountId, billingAccountNumber) {
    const api = await apiClient({ withAuth: true })
    return api.get(
      `/api/v1/accounts/${accountId}/smartPayAsYouGo/eligibility?billingAccountNumber=${billingAccountNumber}`
    )
  },
  /** Starts a signed-in chat for the account (So Energy chat widget). Portal V2 checks ownership. */
  async startAccountChat(accountId) {
    const api = await apiClient({ withAuth: true })
    return api.post(`/api/v1/accounts/${accountId}/chat`)
  },
  async getAccountState(accountId) {
    const api = await apiClient({ withAuth: true })
    return api.get(`/api/v1/accounts/${accountId}/state`)
  },
  async getLoyaltyStatus(accountId) {
    const api = await apiClient({ withAuth: true })
    return api.get(`/api/v1/accounts/${accountId}/loyalty/status`)
  },
  async verifyEvVehicle(registrationPlate) {
    const api = await apiClient()
    return api.post("/api/v1/dvla/checkVehicleIsEv", {
      registrationPlate
    })
  },
  async verifySmartMeter(meterPointIdentifier) {
    const api = await apiClient({ withAuth: true })
    return api.get(
      `/api/v1/meterPoints/${meterPointIdentifier}/checkEvTariffEligibility`
    )
  },
  async updateCustomerDetails(customerId, payload) {
    const api = await apiClient({ withAuth: true })
    return api.patch(`api/v1/customers/${customerId}`, payload)
  },
  async getRenewalQuotes(accountId, payload) {
    const api = await apiClient({ withAuth: true })
    return api.post(`/api/v1/accounts/${accountId}/quotes`, payload)
  },
  async registerRenewalInterest(accountId, payload) {
    const api = await apiClient({ withAuth: true })
    return api.put(`/api/v1/accounts/${accountId}/renewals/interest`, payload)
  },
  async getSmartChargingCompatibleAssets(type) {
    const api = await apiClient()
    return api.get("/api/v1/smartCharging/compatibleAssets", {
      params: type ? { type } : {}
    })
  },
  async checkSmartChargingEligibility(accountId, payload) {
    const api = await apiClient({ withAuth: true })
    return api.post(
      `/api/v1/accounts/${accountId}/smartCharging/eligibilityChecks`,
      payload
    )
  },
  async fetchFeatureFlag() {
    const api = await apiClient()
    return api.get(`/api/v1/config/featureFlags`)
  },
  async getEnergyUsageV2(accountId, params) {
    const api = await apiClient({ withAuth: true })
    return api.get(`/api/v2/accounts/${accountId}/energyUsage`, { params })
  },
  async joinSmartChargingWaitlist(accountId, payload) {
    const api = await apiClient({ withAuth: true })
    return api.post(
      `/api/v1/accounts/${accountId}/smartCharging/waitlist`,
      payload
    )
  }
}
